import { Alert, AlertDescription, AlertTitle } from '@/components/ui/Alert';
import { cn } from '@/lib/utils';
import { CheckCircleIcon, InfoIcon, WarningCircleIcon, type Icon } from '@phosphor-icons/react';
import { iconColorVariants, textVariants } from './toast-variants';
import type { ToastVariant } from './toast.types';
import { ToastProgressIndicator } from './ToastProgressIndicator';
import { Typography } from '@components/ui/Typography';

const iconsMapping: Record<ToastVariant, Icon> = {
  success: CheckCircleIcon,
  destructive: WarningCircleIcon,
  default: InfoIcon,
};

interface CustomToastProps {
  id: string | number;
  title: string;
  duration: number;
  description?: string;
  variant?: ToastVariant;
}

export function Toast({ id, title, duration, description, variant = 'default' }: CustomToastProps) {
  const Icon = iconsMapping[variant] || iconsMapping['default'];

  return (
    <Alert id={id.toString()} className="bg-black w-[50vw] flex gap-3 pb-6 [&>svg]:size-6">
      <Icon className="size-6" color={iconColorVariants({ variant })} />
      <div className="flex flex-col gap-2 flex-1">
        <AlertTitle
          className={cn('text-base font-medium line-clamp-none', textVariants({ variant }))}
        >
          <Typography
            weight="medium"
            className={cn('text-wrap whitespace-pre-wrap', textVariants({ variant }))}
          >
            {title}
          </Typography>
        </AlertTitle>
        {description && (
          <AlertDescription className={cn('text-base', textVariants({ variant }))}>
            <Typography className={cn('whitespace-pre-wrap', textVariants({ variant }))}>
              {description}
            </Typography>
          </AlertDescription>
        )}
      </div>
      <ToastProgressIndicator duration={duration} variant={variant} />
    </Alert>
  );
}
